import { apiGet } from '../common/apiTools';

export async function getFile(url: string): Promise<Blob> {
  return apiGet<Blob>(`${url}`);
}

export async function fetchLoginPage(): Promise<string> {
  return apiGet<string>('/public/api/login-page');
}
